export const API_BASE_URL = "http://dhananjayk.hyderabad.cdac.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "http://satyaprakash.hyderabad.cdac.in:8002/core";
// ==========================================================================
//                                 LOCAL
// ==========================================================================

//  export const USERSERVICE_BASE_URL = "https://ivpisea.isea.in/backend";
//  export const CONFERENCESERVICE_BASE_URL =
//  "https://ivpisea.isea.in/backend/conference";
// export const USERSERVICE_BASE_URL =
//   "https://ivpstaging.hyderabad.cdac.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://ivpstaging.hyderabad.cdac.in/backend/conference";

// export const USERSERVICE_BASE_URL =
//   "http://dhananjayk.hyderabad.cdac.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "http://dhananjayk.hyderabad.cdac.in/backend/conference";

// export const ARMS_BASE_URL = "http://vaibhavp.hyderabad.cdac.in:8001";
// export const ASSESSMENT_BASE_URL = "http://10.244.2.230:9090";
// export const VLABS_BASE_URL = "http://10.244.3.66:8080";
// // export const LMS_BASE_URL = "http://10.244.1.45";
// // export const SSO_BASE_URL = "http://10.244.2.178:8080/digitalnagriks";
// export const CTF_BASE_URL = "http://10.244.2.230:9095";
// export const CISO_BASE_URL = "http://10.244.0.77:8002";
// export const VLABS_BASE_URL_NEW = "http://10.244.3.189:8080";
// export const AWARENESS_BASE_URL = "http://10.244.2.186:8080";
// export const SSO_BASE_URL = "http://10.244.2.240:9595";
// // export const LMS_BASE_URL_NEW = "http://10.244.2.204/local";

// // export const LMS_BASE_URL_NEW = "http://196.12.45.101";
// // export const LMS_BASE_URL_NEW = "http://devlms.hyderabad.cdac.in";
// export const DIGITAL_NAGRIK_BASE_URL =
//   "http://10.244.2.178:8080/digitalnagriks";
// export const SANDBOX_BASE_URL = "http://10.244.0.133:7000/api";
// export const DATASET_BASE_URL = "http://10.244.1.139:6001/stats";
// export const LMS_BASE_URL_LOCAL = "http://10.244.2.204";
// export const LMS_BASE_URL_LOCAL_NEW = "https://isealms.cdachyd.in";

// ==========================================================================
//                                 STAGING
// ==========================================================================

//  export const USERSERVICE_BASE_URL = "https://ivpstaging.hyderabad.cdac.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://ivpstaging.hyderabad.cdac.in/backend/conference";
//  export const ARMS_BASE_URL = "https://cforms-staging.hyderabad.cdac.in/backend";
//  export const ASSESSMENT_BASE_URL = "https://assessment.hyderabad.cdac.in";
//  export const VLABS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
//  export const LMS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
//  export const SSO_BASE_URL = "https://staysafeonline.in";
//  export const CTF_BASE_URL = "https://ctf-ivp.hyderabad.cdac.in";
//  export const CISO_BASE_URL = "https://ciso.hyderabad.cdac.in/backend";

// ==========================================================================
//                                 NEW STAGING
// ==========================================================================

// export const USERSERVICE_BASE_URL =
//   "https://ivp-staging.hyderabad.cdac.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://ivp-staging.hyderabad.cdac.in/backend/conference";
// export const ARMS_BASE_URL = "https://cforms-staging.hyderabad.cdac.in/backend";
// export const ASSESSMENT_BASE_URL = "https://assessment.hyderabad.cdac.in";
// export const VLABS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// export const LMS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// export const SSO_BASE_URL = "https://staysafeonline.in";
// export const CTF_BASE_URL = "https://ctf-ivp.hyderabad.cdac.in";
// export const CISO_BASE_URL = "https://ciso.hyderabad.cdac.in/backend";
// export const LMS_BASE_URL_NEW = "http://196.12.45.101";
// export const DIGITAL_NAGRIK_BASE_URL =
//   "https://digitalnaagrik.hyderabad.cdac.in";
// ==========================================================================
//                                 NEW ONE STAGING
// ==========================================================================

// export const USERSERVICE_BASE_URL = "https://ivp.isea.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://ivp.isea.in/backend/conference";
// export const ARMS_BASE_URL = "https://faas.isea.in/backend";
// export const ASSESSMENT_BASE_URL = "https://assessment.isea.in";
// export const VLABS_BASE_URL = "https://vlab.isea.in";
// export const LMS_BASE_URL = "http://courses.isea.in";
// export const SSO_BASE_URL = "https://staysafeonline.in";
// export const CTF_BASE_URL = "https://ctf.isea.in";
// export const CISO_BASE_URL = "https://ciso.isea.in";
// export const LMS_BASE_URL_NEW = "http://196.12.45.101";
// export const DIGITAL_NAGRIK_BASE_URL = "https://dn.isea.in";

// ==========================================================================
//                                UPDATED STAGING
// ==========================================================================

// export const USERSERVICE_BASE_URL_NEW = "https://ivp.isea.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://ivp.isea.in/backend/conference";
// export const ARMS_BASE_URL = "https://faas.isea.in/backend";
// export const ASSESSMENT_BASE_URL = "https://assessment.isea.in";
// export const VLABS_BASE_URL = "https://vlab.isea.in";
// export const VLABS_BASE_URL_NEW = "https://vlab.isea.in";
// export const LMS_BASE_URL = "http://courses.isea.in";
// export const LMS_BASE_URL_NEW = "http://courses.isea.in";
// export const SSO_BASE_URL = "https://staysafeonline.in";
// export const CTF_BASE_URL = "https://ctf.isea.in";
// export const CISO_BASE_URL = "https://ciso.isea.in/backend";
// export const DIGITAL_NAGRIK_BASE_URL = "https://dn.isea.in";
// export const AWARENESS_BASE_URL = "https://awareness.isea.app";

// ==========================================================================
//                                 PRODUCTION
// ==========================================================================

export const USERSERVICE_BASE_URL = "https://ivp.isea.app/backend";
export const CONFERENCESERVICE_BASE_URL =
  "https://ivp.isea.app/backend/conference";
export const ARMS_BASE_URL = "https://faas.isea.app/backend";
export const ASSESSMENT_BASE_URL = "https://assessment.isea.app";
export const VLABS_BASE_URL = "https://vlab.isea.app";
export const VLABS_BASE_URL_NEW = "https://vlab.isea.app";
export const LMS_BASE_URL = "https://courses.isea.app";
export const LMS_BASE_URL_NEW = "https://courses.isea.app";
export const LMS_BASE_URL_LOCAL_NEW = "https://courses.isea.app";
export const SSO_BASE_URL = "https://staysafeonline.in";
export const CTF_BASE_URL = "https://ctf.isea.app";
export const CISO_BASE_URL = "https://ciso.isea.app/backend";
export const DIGITAL_NAGRIK_BASE_URL = "https://awareness.isea.app";
export const AWARENESS_BASE_URL = "https://awareness.isea.app";
export const SANDBOX_BASE_URL = "https://sandbox.isea.app/backend/api";
export const DATASET_BASE_URL = "https://dataset.isea.app/backend/stats";
// export const LMS_BASE_URL_LOCAL_NEW = "https://isealms.cdachyd.in";

// ==========================================================================
//                                 old PRODUCTION
// ==========================================================================

// export const USERSERVICE_BASE_URL = "https://ivp.cdachyd.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://ivp.cdachyd.in/backend/conference";
// export const ARMS_BASE_URL = "https://faas.isea.app/backend";
// export const ASSESSMENT_BASE_URL = "https://assessment.isea.app";
// export const VLABS_BASE_URL = "https://vlab.isea.app";
// export const LMS_BASE_URL = "https://courses.isea.app";
// // export const LMS_BASE_URL = "https://lms.isea.app";
// export const SSO_BASE_URL = "https://staysafeonline.in";
// //  export const QUIZ_BASE_URL = "https://quiz.isea.app";
// export const CTF_BASE_URL = "https://ctf.isea.app";
// export const CISO_BASE_URL = "https://ciso.isea.app/backend";
// // export const DIGITAL_NAGRIK_BASE_URL = "https://dn.isea.app";
// export const DIGITAL_NAGRIK_BASE_URL = "https://awareness.isea.app"

// ==========================================================================
//                         Test Staging
// ==========================================================================

// export const USERSERVICE_BASE_URL =
//   "https://backend-ivp.hyderabad.cdac.in/backend";
// export const CONFERENCESERVICE_BASE_URL =
//   "https://backend-ivp.hyderabad.cdac.in/backend/conference";
// export const ARMS_BASE_URL = "https://cforms-staging.hyderabad.cdac.in/backend";
// export const ASSESSMENT_BASE_URL = "https://assessment.hyderabad.cdac.in";
// export const VLABS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// export const LMS_BASE_URL = "https://ivplms-staging.hyderabad.cdac.in";
// export const SSO_BASE_URL = "https://staysafeonline.in";
// export const CTF_BASE_URL = "https://ctf-ivp.hyderabad.cdac.in";
// export const CISO_BASE_URL = "https://ciso.hyderabad.cdac.in/backend";

// ==========================================================================
//                         public domain
// ==========================================================================

export const CISO_PUBLIC_URL = "https://ciso.isea.app/";
export const ARMS_PUBLIC_URL = "https://faas.isea.app/";
export const CISO_PUBLIC_URL_Calender = "https://ciso.isea.app/ciso_calendar";
export const AWARENESS_PUBLIC_URL = "https://awareness.isea.app";
export const IVP_PUBLIC_URL = "https://ivp.isea.app";
export const EVENTS_PUBLIC_URL = "https://isea.app/events/";
export const EVENTS_PAGE_PUBLIC_URL = "https://isea.app/event.php/";
export const SSP_PLEDGE_REDIRECT_URL =
  "https://staysafeonline.in/pledge?pledgename";
